<template>
    <div class="video-mask" v-show="show">
        <div class="video-box">
            <span class="video-box--hor"></span>
            <span class="video-box--ver"></span>
            <iframe width="560" height="315" :src="videoUrl" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

            <span class="video-btn--close iconfont iconguanbi" @click="videoClose"></span>
        </div>
    </div>
</template>

<script>
export default {
    name: "play-video",
    props: ["videoUrl", "show"],

    components: {

    },
    data: () => ({
        top: 0,
    }),
    created() {

    },
    mounted() {

    },
    watch: {
        show(val) {
            this.HOME_FULLPAGE.scrollDisable = val      // 禁用滚动
        }
    },
    computed: {
        HOME_FULLPAGE() {
            return this.$store.state.HOME_FULLPAGE;
        }
    },
    methods: {
        videoClose() {
            this.$store.commit("SET_VIDEO", {
                videoUrl: "",
                videoShow: false
            })
        }
    },
};
</script>

<style lang="scss" scoped>
.video-mask {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 999;
    background: rgba(0,0,0,.8);

    .video-box {
        width: pxTorem(1068px);
        height: pxTorem(600px);
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        background: #000;
        background-size: 100%;

        .video-btn--close {
            position: absolute;
            bottom: 102%;
            right: 0;
            font-size: pxTorem(34px);
            color: #fff;
            cursor: pointer;
        }

        &--hor {
            &::before {
                content: "";
                position: absolute;
                background: url("../assets/images/home/video_border.png") no-repeat;
                background-size: cover;

                top: 0;
                left: 0;
                right: 0;
                height: 10px;
                background-position: 50% 0;
            }
            &::after {
                content: "";
                position: absolute;
                background: url("../assets/images/home/video_border.png") no-repeat;
                background-size: cover;

                bottom: 0;
                left: 0;
                right: 0;
                height: 10px;
                background-position: 50% 100%;
            }
        }

        &--ver {
            &::before {
                content: "";
                position: absolute;
                background: url("../assets/images/home/video_border.png") no-repeat;
                background-size: cover;

                top: 0;
                bottom: 0;
                left: 0;
                width: 12px;
                background-position: 0 0;
            }
            &::after {
                content: "";
                position: absolute;
                background: url("../assets/images/home/video_border.png") no-repeat;
                background-size: cover;

                top: 0;
                bottom: 0;
                right: 0;
                width: 12px;
                background-position: 100% 0;
            }
        }

        iframe {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
